import Constant from '@/common/constant/Constant';
import localStorageUtil from '@/common/utils/localStorageUtil';
import Utils from '@/common/utils/utils';
import LoadingPanel from '@/component/common/LoadingPanel';
import { Button } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import { Auth } from 'aws-amplify';
import { useSnackbar } from 'notistack';
import { useEffect, useRef, useState } from 'react';

import { closeTabId, multiPanelAtom } from '@/state/atom/panelAtom';
import { closePanelTabSelector } from '@/state/selector/panelSelector';
import CancelTabsDialog from './dialog/CancelTabsDialog';
import ConfirmDeleteOrgUserDialog from './dialog/ConfirmDeleteOrgUserDialog'; 
import RejectDeleteOrgUser from './dialog/RejectDeleteOrgUser';

import './UserManagement.css';
import './dialog/ConfirmDeleteOrgUserDialog.css';

import {
    getProjectBase,
    getUserList,
    handleAddNew,
    handleTextFieldOnClick,
    initAddUser,
    isDisableChangeAdmin,
    isDisableChangeUserType,
    onChangeAdminPremissionSelect,
    onChangeUserTypeSelect,
    onEditSelect,
    onSubmit,
    checkDisableBtnSubmit,
    onDeleteOrShowModalUser,
    onClickCancelEdit,
    handleEditTextField,
    deleteOrgUser,
    isDisableBtnEditUser,
    isDisableBtnRestore,
    onRestoreSelect,
    onSubmitRestoreUser
} from '@/component/system/handler/UserManagementHandler';

import { corporationAtom } from '@/state/atom/corporationAtom';
import { userAtom } from '@/state/atom/userAtom';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import CancelDialogAddUser from './CancelDialogAddUser';
import OverFlowTooltip from '../common/OverFlowTooltip';
import DataChangePleaseReloadModal from '@/component/common/modal/DataChangePleaseReloadModal';
import ConfirmDeleteNewOrgUserDialog from './dialog/ConfirmDeleteNewOrgUserDialog';
import ConfirmRestoreUser from '../common/modal/ConfirmRestoreUser';
import ConfirmDialog from '../../common/dialog/ConfirmDialog';

// import child element component
import AddUserRow from './UserManagementElement/AddUserRow';
import { S3Image } from 'aws-amplify-react';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function UserManagement(props) {
    // Re-render when the translation dictionary loads/extends so tr() labels update.
    useTranslationSubscription();

    // common userDetail state
    const [userDetail, setUserDetail] = useRecoilState(userAtom);

    // common corporationDetail state
    const corporationDetail = useRecoilValue(corporationAtom);
    // close tabs
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const [closeTabIdState, setCloseTabIdState] = useRecoilState(closeTabId);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const [isConfirmCancelTabs, setIsConfirmCancelTabs] = useState(false);


    // message
    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setIsLoading] = useState(false);
    const [userList, setUserList] = useState([]);
    const [userAdd, setUserAdd] = useState(initAddUser(corporationDetail));
    const [userDeleteList, setUserDeleteList] = useState([]);
    const [userChangePermissionList, setUserChangePermissionList] = useState([]);
    const [userChangeTypeList, setUserChangeTypeList] = useState([]);
    const [projectBase, setProjectBase] = useState({});
    const [projectList, setProjectList] = useState([]);
    const [isDisableBtnDelete, setIsDisableBtnDelete] = useState({});

    const [userAddList, setUserAddList] = useState([]);
    const [errorAddList, setErrorAddList] = useState({});

    const [isDisableBtnSubmit, setIsDisableBtnSubmit] = useState(true);
    const [openConfirmModal, setOpenConfirmModal] = useState({ isOpen: false, userId: '' });
    const [openCancelDialog, setOpenCancelDialog] = useState(false);

    const [editUserList, setEditUserList] = useState([]);
    const [errorEditList, setErrorEditList] = useState({});

    const [isOpenDialogConfirmDelete, setIsOpenDialogConfirmDelete] = useState({
        isEnable: false,
        userId: null
    });
    const [isOpenModalRejectDeleteUser, setIsOpenModalRejectDeleteUser] = useState(false);
    const [errorDeleteUserMsgCode, setErrorDeleteUserMsgCode] = useState('');
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);
    const [isOpenDialogConfirmRestoreUser, setIsOpenDialogConfirmRestoreUser] = useState(false);

    const [selectedUser, setSelectedUser] = useState({});
    const [isOpenDialogChangedData, setIsOpenDialogChangedData] = useState(false);
    const [isOpenDialogEditUser, setIsOpenDialogEditUser] = useState(false);
    const [dialogEditUserError, setDialogEditUserError] = useState('');

    const argsAll = {
        ...props,
        API: props?.API,
        corporationId: localStorageUtil.getAffiliationOrganization(),
        username: Auth.user.username,
        userId: userDetail.id,
        corporationDetail: corporationDetail,
        isDisableBtnDelete: isDisableBtnDelete,
        userDetail: userDetail,
        userList,
        userAdd,
        userAddList,
        errorAddList,
        setIsLoading: setIsLoading,
        setUserList: setUserList,
        setUserDetail: setUserDetail,
        setUserAdd: setUserAdd,
        setUserAddList: setUserAddList,
        setUserDeleteList: setUserDeleteList,
        setUserChangePermissionList: setUserChangePermissionList,
        setUserChangeTypeList: setUserChangeTypeList,
        setProjectBase: setProjectBase,
        setProjectList: setProjectList,
        setIsDisableBtnDelete: setIsDisableBtnDelete,
        enqueueSnackbar: enqueueSnackbar,
        setErrorAddList: setErrorAddList,
        setIsDisableBtnSubmit: setIsDisableBtnSubmit,
        setOpenConfirmModal: setOpenConfirmModal,
        setOpenCancelDialog: setOpenCancelDialog,
        setEditUserList: setEditUserList,
        setErrorEditList: setErrorEditList,
        openCancelDialog: openCancelDialog,
        userChangePermissionList: userChangePermissionList,
        userChangeTypeList: userChangeTypeList,
        userDeleteList: userDeleteList,
        errorEditList: errorEditList,
        editUserList: editUserList,
        isConfirmCancelTabs,
        setIsConfirmCancelTabs,
        panelList,
        setPanelList,
        closePanelTab,
        isOpenDialogConfirmDelete,
        setIsOpenDialogConfirmDelete,
        isOpenModalRejectDeleteUser,
        setIsOpenModalRejectDeleteUser,
        projectBase,
        errorDeleteUserMsgCode,
        setErrorDeleteUserMsgCode,
        isOpenModalReloadPage,
        setIsOpenModalReloadPage,
        isOpenDialogConfirmRestoreUser, 
        setIsOpenDialogConfirmRestoreUser,
        selectedUser, 
        setSelectedUser,
        isOpenDialogChangedData,
        setIsOpenDialogChangedData,
        setIsOpenDialogEditUser,
        dialogEditUserError,
        setDialogEditUserError
    };

    const isMountedGetUserList = useRef(null);
    useEffect(() => {
        isMountedGetUserList.current = true;

        const fetchUserListAndPrjBase = async () => {
            await Promise.all([
                // get user list
                getUserList(argsAll),
                // get project base detail by corporationId
                getProjectBase(argsAll),
            ]);
    
            return true;
        }

        fetchUserListAndPrjBase()
            .then(res => {
                if (res && isMountedGetUserList.current) {
                    argsAll.setIsLoading(false);
                }
            })
            .catch(err => {
                console.log('fetchUserListAndPrjBase err: ', err)
                argsAll.setIsLoading(false);
            })

        return () => {
            if (isMountedGetUserList.current) {
                isMountedGetUserList.current = false;
            }
        }
    }, []);

    useEffect(() => {
        checkDisableBtnSubmit(argsAll);
    }, [
        userAddList,
        userChangePermissionList,
        userChangeTypeList,
        userDeleteList,
        editUserList]);

    useEffect(() => {
        if (props.tabId === closeTabIdState) {
            if (!Utils.isEmptyArray(userAddList) || !isDisableBtnSubmit || !Utils.isEmptyArray(userDeleteList)) {
                setIsConfirmCancelTabs(true);
            } else {
                let currentPanelInfo = Utils.getPanelInfo(props.panelId, panelList);
                if (!currentPanelInfo || Utils.isEmptyObject(currentPanelInfo)) return;
                closePanelTab({
                    event: null,
                    panelType: currentPanelInfo.type,
                    panelId: props.panelId,
                    tabId: props.tabId
                });
            }
            setCloseTabIdState(0);
        }
    },[closeTabIdState])

    const getEditUser = (user, field) => {
        if (editUserList.length === 0) return null;
        const editUser = editUserList.filter((e) => e.id === user.id);
    
        if (editUser.length) return editUser[0][field];
        return null;   
    } 

    const checkDisableBtnCancel = () => {
        let disable = false;
        if (Utils.isEmptyArray(userAddList) && Utils.isEmptyArray(editUserList)) {
            disable = true;
        }
        return disable;
    }

    const showGroupButton = () => {
        let show = false;
        if (userAddList.length > 0 || editUserList.length > 0) {
            show = true;
        }
        return show;
    }

    // render user type
    const renderUserType = (user, index) => {
        if (
            userDetail.id !== user.id &&
            (Constant.USER_TYPE.INTERNAL === user.type || Utils.isGeneralUserWithoutGuest(user))
        ) {
            return (
                <FormControl className="form-control--wrap form-control--hg32">
                    <Select
                        variant="outlined"
                        MenuProps={{
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left'
                            },
                            transformOrigin: {
                                vertical: 'top',
                                horizontal: 'left'
                            },
                            getContentAnchorEl: null,
                            className: 'selectDrop'
                        }}
                        defaultValue={user.type}
                        value={user.type}
                        disabled={isDisableChangeUserType(userDetail, user)}
                        onChange={event =>
                            onChangeUserTypeSelect(
                                index,
                                event,
                                userList,
                                userChangeTypeList,
                                projectBase,
                                argsAll,
                                projectList
                            )
                        }
                    >
                        <MenuItem value={Constant.USER_TYPE.GENERAL}>{trI18n('GENERAL_USER')}</MenuItem>
                        <MenuItem value={Constant.USER_TYPE.INTERNAL}>{trI18n('INTERNAL_USER')}</MenuItem>
                    </Select>
                </FormControl>
            );
        }
        return (
            <FormControl className="form-control--wrap form-control--hg32">
                <Select
                    variant="outlined"
                    MenuProps={{
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'left'
                        },
                        transformOrigin: {
                            vertical: 'top',
                            horizontal: 'left'
                        },
                        getContentAnchorEl: null,
                        className: 'selectDrop'
                    }}
                    value={user.type}
                    disabled={true}
                >
                    <MenuItem value={Constant.USER_TYPE.GENERAL}>{trI18n('GENERAL_USER')}</MenuItem>
                    <MenuItem value={Constant.USER_TYPE.INTERNAL}>{trI18n('INTERNAL_USER')}</MenuItem>
                    <MenuItem value={Constant.USER_TYPE.CUSTOMER}>{tr('BTOC')}</MenuItem>
                </Select>
            </FormControl>
        );
    };

    // render tbl user list
    const renderTblUserList = () => {
        let listItems = userList.map((user, i) => (
            <TableRow key={user.id}>
                <TableCell>
                    {user.isDelete !== undefined && user.isDelete ? (
                        <div className='table--column-avatar-user'>
                            <div className='fixed-with-avatar'>
                                {user.image ? (<S3Image
                                    imgKey={user.image}
                                    width="24px"
                                />) : (
                                    <img src={Constant.AVATAR_DEFAULT} alt="" width="24px"/>
                                )}
                            </div>
                            <del className='break-word-email'>{Utils.getDisplayUserEmailWithoutSuffix(user.mail)}</del>
                        </div>
                    ) : (
                        <div className='table--column-avatar-user'>
                            <div className='fixed-with-avatar'>
                                {user.image ? (<S3Image
                                    imgKey={user.image}
                                    width="24px"
                                />) : (
                                    <img src={Constant.AVATAR_DEFAULT} alt="" width="24px"/>
                                )}
                            </div>
                            <span className='break-word-email'>{Utils.getDisplayUserEmailWithoutSuffix(user.mail)}</span>
                        </div>
                    )}
                </TableCell>
                <TableCell>
                    {
                        user.editing ?
                            <TextField
                                error={errorEditList[`${user.id}`] && errorEditList[`${user.id}`].lastName}
                                helperText={
                                    errorEditList[`${user.id}`] && errorEditList[`${user.id}`].lastName
                                }
                                className="form-control table-row-content-middle"
                                variant="outlined"
                                id={`lastName-${user.id}`}
                                placeholder={tr('姓')}
                                InputProps={{ className: 'user-lastName' }}
                                value={getEditUser(user, 'lastName')}
                                onChange={e => handleEditTextField(e, user.id, argsAll)}
                                onClick={e => {
                                    handleTextFieldOnClick(e);
                                }}
                            />
                        :
                    
                        <OverFlowTooltip value={Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, user.lastName)}/>
                    }
                </TableCell>
                <TableCell>
                    {
                        user.editing ?
                            <TextField
                                error={errorEditList[`${user.id}`] && errorEditList[`${user.id}`].firstName}
                                helperText={
                                    errorEditList[`${user.id}`] && errorEditList[`${user.id}`].firstName
                                }
                                className="form-control table-row-content-middle"
                                variant="outlined"
                                id={`firstName-${user.id}`}
                                placeholder={tr('名')}
                                InputProps={{ className: 'user-lastName' }}
                                value={getEditUser(user, 'firstName')}
                                onChange={e => handleEditTextField(e, user.id, argsAll)}
                                onClick={e => {
                                    handleTextFieldOnClick(e);
                                }}
                            />
                        :
                    
                        <OverFlowTooltip value={Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, user.firstName)}/>
                    }
                </TableCell>
                <TableCell>
                    <div className={`user-status user-status-${Utils.getUserStatus(user).toLowerCase()}`}>
                    {tr(Utils.getUserStatus(user))}
                    </div>
                </TableCell>
                <TableCell
                    className={
                        user.isChangeUserType !== undefined && user.isChangeUserType
                            ? 'background-change-permission-select'
                            : ''
                    }
                >
                    {renderUserType(user, i)}
                </TableCell>
                {/* change admin permission */}
                <TableCell
                    className={
                        user.isChangePermission !== undefined && user.isChangePermission
                            ? 'background-change-permission-select'
                            : ''
                    }
                >
                    <div className="switch-check">
                        <input
                            type="checkbox"
                            id={`switch-admin-${i}`}
                            disabled={isDisableChangeAdmin(userDetail, user, argsAll)}
                            defaultChecked={Utils.isAdminUser(user) ? true : false}
                            checked={Utils.isAdminUser(user) ? true : false}
                        />
                        <label
                            htmlFor={`switch-admin-${i}`}
                            onClick={event => {
                                if (isDisableChangeAdmin(userDetail, user, argsAll)) return;
                                onChangeAdminPremissionSelect(
                                    i,
                                    userList,
                                    userChangePermissionList,
                                    argsAll
                                );
                            }}
                        />
                    </div>

                    
                </TableCell>
                {/* restore - edit - delete user */}
                <TableCell>
                    <div className="editUserGroupBtn">
                    {!isDisableBtnRestore(user) && (
                        <Button
                            className="groupBtnOrgInCorp"
                            disabled={isDisableBtnRestore(user)}
                            onClick={() => {
                                onRestoreSelect(argsAll, user);
                            }}
                        >
                            <img
                                src="/assets/image/icon-restore.svg"
                                alt=""
                            />
                        </Button>
                    )}
                        <Button
                            className="groupBtnOrgInCorp"
                            disabled={isDisableBtnEditUser(argsAll, user)}
                            onClick={() => {
                                onEditSelect(i, argsAll, user);
                            }
                            }
                        >
                            <img
                                src="/assets/image/edit-icon.svg"
                                alt=""
                            />
                        </Button>
                       {user.active !== Constant.ACTIVE_FLAG.DELETED && <Button
                            className="groupBtnOrgInCorp"
                            onClick={() => deleteOrgUser(argsAll, user)}
                        >
                            <img
                                src="/assets/image/delete-icon.svg"
                                alt=""
                            />
                        </Button>}
                    </div>
                </TableCell>
            </TableRow>
        ));

        let tbl = (
            <div className="table-tbl table-tbl--account">
                <Table data-cy="system-user-list-table" style={{borderCollapse: 'separate', borderSpacing: 0}}>
                    <TableHead>
                        <TableRow>
                            {/* <TableCell></TableCell> */}
                            <TableCell>
                                {tr('ユーザーID（メールアドレス）')}<span style={{ color: 'red' }}>*</span>
                            </TableCell>
                            <TableCell>
                                {tr('姓')} <span style={{ color: 'red' }}>*</span>
                            </TableCell>
                            <TableCell>
                                {tr('名')} <span style={{ color: 'red' }}>*</span>
                            </TableCell>
                            <TableCell>{tr('ステータス')}</TableCell>
                            <TableCell>{trI18n('USER01LB016')}</TableCell>
                            <TableCell>{tr('組織マネージャ―')}</TableCell>
                            <TableCell className='groupBtnRestoreEditDelete'>{tr('操作')}</TableCell>
                        </TableRow>
                    </TableHead>
                    {/* add user */}
                    {Utils.isAdminUser(userDetail) && <TableBody>{renderFormAddUser()}</TableBody>}
                    <TableBody>{listItems}</TableBody>
                </Table>
                {isOpenDialogConfirmDelete.isEnable && (
                    <ConfirmDeleteOrgUserDialog argsAll={argsAll} />
                )}
                {isOpenModalRejectDeleteUser && (
                    <RejectDeleteOrgUser argsAll={argsAll} isOpen={isOpenModalRejectDeleteUser} setIsOpen={setIsOpenModalRejectDeleteUser} errorMsgCode={errorDeleteUserMsgCode} />
                )}
            </div>
        );
        return tbl;
    };

    const updateUserAddDetail = (index, detailUser, error = '') => {
        let cloneUserAddList = [...argsAll.userAddList];
        cloneUserAddList.splice(index, 1, { ...detailUser });
        if (error) {
        }
        argsAll.setUserAddList(cloneUserAddList);
    }
    // render form add user
    const renderFormAddUser = () => {
        let listItemsAdd = userAddList.map((user, i) => (
            <AddUserRow
                key={i}
                currentAddList={userAddList}
                userList={userList}
                userAddDetail={user}
                currentIndex={i}
                updateUserAddDetail={updateUserAddDetail}
                onDeleteOrShowModalUser={() => onDeleteOrShowModalUser(user, argsAll)}
                errorAddList={errorAddList[user?.id] ? errorAddList[user?.id] : {}}
            />
        ));

        return listItemsAdd;
    };

    return (
        <div className="groupUser">
            <LoadingPanel isLoading={isLoading} />

            <div className="head-btn">
                <div className="head-btn-add">
                    {Utils.isAdminUser(userDetail) && (
                        <Button className="btn-add-project" onClick={e => handleAddNew(argsAll)}>
                            <div className="btn-plus-icon">
                                <img src="/assets/image/icon-plus-add.svg" alt="" />
                            </div>
                            <div className="btn-text-add">{trI18n('USER09BTN001')}</div>
                        </Button>
                    )}
                </div>
                <div className="head-btn-wrap" style={{minHeight: '32px'}}>
                    {showGroupButton() && <>
                        <div className="btn-cancel">
                            <Button
                                className="btn-light btn-hg32"
                                variant="contained"
                                color="primary"
                                disabled={checkDisableBtnCancel()}
                                onClick={() => onClickCancelEdit(argsAll)}
                            >
                                {trI18n('COMBTN001')}
                            </Button>
                        </div>
                        <div className="btn-submit">
                            <Button
                                className="btn-primary btn-hg32"
                                variant="contained"
                                color="primary"
                                disabled={isDisableBtnSubmit}
                                onClick={() =>
                                    onSubmit(
                                        userChangePermissionList,
                                        userChangeTypeList,
                                        argsAll
                                    )
                                }
                            >
                                {trI18n('COMBTN011')}
                            </Button>
                        </div>
                    </>}
                </div>
            </div>

            {/* user list */}
            <div className="group-user">
                <div className="user-table">{userList && renderTblUserList()}</div>
            </div>
            {/* Cofirm modal delete user*/}
            <ConfirmDeleteNewOrgUserDialog openConfirmModal={openConfirmModal} argsAll={argsAll} />

            <CancelDialogAddUser isOpen={openCancelDialog} argsAll={argsAll} />
            <CancelTabsDialog argsAll={argsAll}/>
            <DataChangePleaseReloadModal {...argsAll} isOpen={isOpenModalReloadPage} setIsOpen={setIsOpenModalReloadPage} />
            <ConfirmRestoreUser 
                isOpen={isOpenDialogConfirmRestoreUser}
                setIsOpen={setIsOpenDialogConfirmRestoreUser}
                submitAction={() => onSubmitRestoreUser(argsAll)}
            />
            <ConfirmDialog 
                isOpen={isOpenDialogEditUser} 
                okCallBack={() => {setIsOpenDialogEditUser(false)}} 
                msgConfirm={dialogEditUserError ? trI18n(dialogEditUserError) : ''}
                textSubmit={trI18n('COMBTN006')}
            />
        </div>
    );
}
